import React, { useCallback, SyntheticEvent, useRef, useEffect, FC } from 'react';
import { tryInvoke } from '@factorin/util';

import { Portal } from '../Portal';
import { cn, stopPropagation } from '../../utils';
import styles from './index.module.scss';


export type ClosingOverlayProps = {
    darken?: boolean;
    zIndex?: number;
    onClose: () => void;
    /**
     * Close on scroll
     */
    closeOnWheel?: boolean;
}

/**
 * Used to darken the background when displaying modal windows
 */
export const ClosingOverlay: FC<ClosingOverlayProps> = ({
    darken, zIndex = 0, onClose, closeOnWheel,
}) => {
    const overlayRef = useRef<HTMLDivElement>();

    useEffect(
        () => {
            const ref = overlayRef.current;
            const onWheel = () => {
                if (closeOnWheel)
                    tryInvoke(onClose);
            };
            if (ref)
                ref.addEventListener('wheel', onWheel, { passive: true });
            return () => ref.removeEventListener('wheel', onWheel);
        },
        [closeOnWheel, onClose],
    );

    return (
        <Portal>
            <div
                ref={overlayRef}
                role='presentation'
                onClick={useCallback(
                    (e: SyntheticEvent) => {
                        stopPropagation(e);
                        tryInvoke(onClose);
                    },
                    [onClose],
                )}
                style={{ zIndex }}
                className={cn(styles.closingOverlay, {
                    [styles.darken]: darken,
                })}
            />
        </Portal>
    );
};
